export default __webpack_public_path__ + "static/media/H1005.5.d3196f3a.mp3";